import { Icon } from '@material-ui/core'
import { useClasses } from './classes'

const Sync = () => {
  const classes = useClasses()
  return <Icon className={classes.sync}>sync</Icon>
}

export default Sync
